<template>
  <div>
    <b-autocomplete
      class="mb-md"
      v-model="collection"
      size="is-medium"
      :data="collections"
      :loading="loading"
      placeholder="Search for a collection..."
      @typing="loadCollections"
      @select="selectCollection">
      <template slot-scope="props">
        <div>
          <p class="">{{ props.option.title }}</p>
          <p class="has-text-grey">ID: {{ props.option.id }}</p>
        </div>
      </template>
    </b-autocomplete>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import debounce from 'lodash/debounce'
export default {
  components: {

  },
  computed: {
    ...mapGetters(['context']),
    endpoint () {
      return this.context.route + '/shopify/' + this.account.id + '/collections/'
    },
    query () {
      return {
        params: {
          search: this.collection
        }
      }
    }
  },
  data () {
    return {
      name: null,
      loading: false,
      collections: [],
      collection: null
    }
  },
  methods: {
    loadCollections: debounce(function (name) {
      if (name === null || name.length === 0) {
        this.collections = []
        return
      }
      this.loading = true
      this.$http.get(this.endpoint, this.query).then(response => {
        this.collections = response.data.collections
      }).finally(() => {
        this.loading = false
      })
    }, 500),
    selectCollection (collection) {
      this.$emit('input', collection)
    }
  },
  mounted () {

  },
  props: ['account']
}
</script>
